import {Component, Directive, EventEmitter, Input, Output, QueryList, ViewChildren} from "@angular/core";
import {AdminResultCaseService} from "../../case.service";
import {ViewManagerService} from "../../../../services/view-manager.service";
import {ResultCase, ScreeningAlert} from "../../../../model/lookup-results.model";
import {Observable} from "rxjs";

export type SortColumn = keyof ResultCase | '';
export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { asc: 'desc', desc: '', '': 'asc' };

const compare = (v1: string | number | any, v2: string | number | any) => (v1 < v2 ? -1 : v1 > v2 ? 1 : 0);

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()',
  },
})
export class NgbdSortableHeader {
  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}

@Component({
  selector: "admin-results-case-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.css"]
})
export class AdminResultsCaseListComponent {

  result: ResultCase[];

  page: number = 1;
  pageSize: number = 25;

  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  constructor(
    private caseService: AdminResultCaseService,
    private viewManager: ViewManagerService
  ) {
    const results$ = this.caseService.resultsSubject.asObservable();
    results$.subscribe(results => {
      this.page = 1;
      this.paginate();
    });
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    for (const header of this.headers) {
      if (header.sortable !== column) {
        header.direction = '';
      }
    }

    // sorting countries
    if (direction === '' || column === '') {
    } else {
      this.result = this.caseService.resultsSubject.value.sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  get all() {
    return this.caseService.resultsSubject.value;
  }

  paginate() {
    this.result = this.caseService.resultsSubject.value.map((one, i) => ({ id: i + 1, ...one })).slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize,
    );
  }

  riskClass(risk: string) {
    if (risk == "high") {
      return "high";
    } else if (risk == "medium") {
      return "medium";
    } else if (risk == "low") {
      return "low";
    }
    return "none";
  }

  statusClass(status: string) {
    if (status == "NEW") {
      return "new";
    } else if (status == "OPEN") {
      return "open";
    } else if (status == "CLOSED") {
      return "closed";
    } else if (status == "REPORTED") {
      return "reported";
    }
    return "";
  }

}
